<template>
    <div :style="{width, height}" class="statisDiv">
        <div class="contentClass">
            <img class="gemstoneClass" src="../src/assets/imgs/gemstoneImg.png" alt="">
            <div class="describeClass">{{describeText}}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        width: String,
        height: String,
        describeText: String
    },
    data(){
        return{

        }
    }
}
</script>

<style lang="scss" scoped>
.statisDiv{
    display: flex;
    // flex-direction: column;
    width: 100%;
    height: 100%;
    background-image: url('../src/assets/imgs/leftModelling.png');
    background-size: 100% 100%;
    // background-color: aquamarine;
}
.contentClass{
    display: flex;
    margin: 0 0 auto 18%;
    // background-color: #79beec;
}

.gemstoneClass{
    width: 30px;
    height: 30px;
    background-size: 100% 100%;
}
.describeClass{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    margin-top: 3px;
    color: #FFFFFF;
    font-weight: bold;
    font-size: 20px;    
}
@media (max-width:768px){
	.contentClass{
		margin:-7px 0 auto 15% !important;	
	}
	.describeClass{
		font-size: 14px;
	}
}
</style>